import React, { createContext, useContext } from 'react';
import { loadStripe } from '@stripe/stripe-js';

const StripeContext = createContext();

const stripePromise = loadStripe(import.meta.env?.VITE_STRIPE_PUBLISHABLE_KEY);

export const StripeProvider = ({ children }) => {
  const stripeOptions = {
    // Global Stripe options for the Tixful theme
    appearance: {
      theme: 'stripe',
      variables: {
        colorPrimary: '#3B82F6', // Tixful blue
        colorBackground: '#ffffff',
        colorText: '#1F2937',
        colorDanger: '#EF4444',
        fontFamily: 'Inter, system-ui, sans-serif',
        spacingUnit: '4px',
        borderRadius: '8px',
      },
      rules: {
        '.Label': {
          fontWeight: '500',
          fontSize: '14px',
          marginBottom: '8px'
        },
        '.Input': {
          padding: '12px 16px',
          border: '1px solid #D1D5DB',
          borderRadius: '8px',
          fontSize: '16px'
        },
        '.Input:focus': {
          borderColor: '#3B82F6',
          boxShadow: '0 0 0 3px rgba(59, 130, 246, 0.1)'
        }
      }
    }
  };

  return (
    <StripeContext.Provider value={{ stripePromise, stripeOptions }}>
      {children}
    </StripeContext.Provider>
  );
};

export const useStripeContext = () => {
  const context = useContext(StripeContext);
  if (!context) {
    throw new Error('useStripeContext must be used within a StripeProvider');
  }
  return context;
};